class ProductItemPayment {
  constructor({
    itemRef,
    itemName,
    categoryName,
    subCategoryName,
    productSkuList,
    qty = 1,
    retailPrice,
    categoryId,
    subCategoryId,
    imageUrl,
    productId,
    code,
    skip_stock,
  }) {
    this.itemRef = itemRef;
    this.categoryName = categoryName;
    this.subCategoryName = subCategoryName;
    this.productName = itemName;
    this.productSku = productSkuList;
    this.qty = qty;
    this.chargeAmount = retailPrice;
    this.productCategoryId = categoryId;
    this.productSubCategoryId = subCategoryId;
    this.productId = productId;
    this.imageUrl = imageUrl;
    this.code = code;
    this.skip_stock = skip_stock;
  }

  increaseQty(qty = 1) {
    this.qty += qty;
  }

  decreaseQty(qty = 1) {
    this.qty -= qty;
  }

  decreateAllQty() {
    this.qty = 0;
  }

  getImage() {
    return this.imageUrl;
  }

  getRevenue() {}

  getPayloadData() {
    return {
      item_ref: this.itemRef,
      item_type: "product",
      event_code: "BUY",
      product_category_name: this.categoryName,
      product_sub_category_name: this.subCategoryName,
      product_name: this.productName,
      skip_stock: this.skip_stock,
      product_code: this.code,
      //product_sku: this.productSku, ไม่ตัด stock ไม่ต้องส่ง qty มา
      qty: this.qty, // ไม่ตัด stock ไม่ต้องส่ง qty มา
      charge_amount: this.getTotalPayment(),
      // price: this.getTotalPayment(),
      paid_amount: this.getTotalPayment(), //Start at ZERO --> will be decide on checkout
      discount_amount: 0, //Start at ZERO --> will be decide on checkout
      product_category_id: this.productCategoryId,
      product_sub_category_id: this.productSubCategoryId,
      product_id: this.productId,
    };
  }

  getTotalPayment() {
    return Number(this.chargeAmount) * this.qty;
  }
}

export default ProductItemPayment;
